<template>
    <modal ref="settings" @hidden="$emit('closed')" :options="{  close: {  onBlur: false,  onEsc: false  }  }" :size="modalSize">
        <h3 slot="modal-title">
            <i class="fas fa-road"></i> {{resource('JourneyBuilder_conditionsettings_Title')}}
        </h3>

        <div slot="modal-body">
            <tabbed-menu
                    :initial-tab="initialTab"
                    :tabs="[{
                        name: tabs.generalSettings,
                        label: resource('JourneyBuilder_conditionsettings_Title')
                    }, {
                        name: tabs.deduplicationSettings,
                        label: resource('JourneyBuilder_DeduplicationSettings_Title')
                    }]"
            >
                <template :slot="tabs.generalSettings">
                    <journey-connection-general-settings ref="generalSettings"
                        @validated="generalSettingsValid = $event"
                                                    
                        :available-conditions="availableConditions"
                        :connection="connection"

                        :name.sync="model.generalSettings.name"
                        :start-date.sync="model.generalSettings.startDate"
                        :is-disabled.sync="model.generalSettings.isDisabled"
                        :delay.sync="model.generalSettings.delay"
                        :steam-campaign.sync="steamCampaign"
                        :email-campaign.sync="emailCampaign"
                        :group-by-title.sync="groupByTitle"
                        :action-conditions.sync="model.generalSettings.actionConditions"
                        :content-settings.sync="model.generalSettings.contentSettings"
                                     
                        :available-action-conditions="availableActionConditions"
                        :emailCampaigns="emailCampaigns"
                        :steamCampaigns="steamCampaigns"
                    >
                    </journey-connection-general-settings>
                </template>
                
                <template :slot="tabs.deduplicationSettings">
                    <journey-connection-deduplication-settings
                        :is-disabled.sync="model.deduplicationSettings.isDisabled"
                        :field-name.sync="model.deduplicationSettings.fieldName"
                    >
                    </journey-connection-deduplication-settings>
                </template>
            </tabbed-menu>

        </div>

        <div slot="modal-footer">
            <settings-controls
                :disable-save="!isValid"
                :prompt="{
                    title: resource('JourneyBuilder_FilterSettings_Delete_Title'),
                    body: resource('JourneyBuilder_FilterSettings_Delete_Body')
                }"
                @cancel="$refs.settings.hide()"
                @delete="deleteConnection"
                @save="saveConnection"
            >
                
            </settings-controls>
        </div>
    </modal>
</template>

<script>
    import api from '../../../api';
    import permissionsMixin from '../../../Mixins/journey-permissions';
    import resources from '../../../../../Util/Mixins/resources';
    
    import Modal,{sizes} from '../../../../../Components/Util/Modal.vue';
    import TabbedMenu from "../../../../../Components/Navigation/TabbedMenu.vue";
    import JourneyConnectionGeneralSettings from "./JourneyConnectionGeneralSettings.vue";
    import JourneyConnectionDeduplicationSettings from "./JourneyConnectionDeduplicationSettings.vue";
    import SettingsControls from '../../SettingsControls.vue';
    import {conditionTypes} from "../../../ConnectionSettings/condition-types";
    import { bootstrapDangerGrowl } from '../../../../../Util/growler';
    import {subTypes} from "../../../Bricks/brick-types";

    const tabs = {
        generalSettings: 'GeneralSettings',
        deduplicationSettings: 'DeduplicationSettings'
    };
    
    export default {
        name: 'journey-connection-settings',
        mixins: [resources, permissionsMixin],
        components: {
            Modal,
            TabbedMenu,
            JourneyConnectionGeneralSettings,
            JourneyConnectionDeduplicationSettings,
            SettingsControls
        },
        created() {
            this.resetModel();
        },
        methods: {
            resetModel(){
                const vm = this;

                api.getTouchPointParentTypes().then((types) => {
                    vm.touchPointTypes = types.map((type) => { 
                        return { 
                            id: type, 
                            label: type
                        }
                    });
                }, bootstrapDangerGrowl);
                
                api.getEmailCampaigns().then((campaigns) => {
                    vm.emailCampaigns = campaigns.map((campaign) => { 
                        return { 
                            id: campaign.id, 
                            label: campaign.name
                        } 
                    });
                }, bootstrapDangerGrowl);
        
                api.getSteamCampaigns().then((campaigns) => {
                    vm.steamCampaigns = campaigns.map((campaign) => { 
                        return { 
                            id: campaign.id, 
                            label: campaign.name
                        } 
                    });
                }, bootstrapDangerGrowl);
        
                api.getTouchpointTypes().then((types) => {
                    vm.touchPointSubTypes = types;
                }, bootstrapDangerGrowl);
        
                const arrivalCondition = vm.connection.conditions.find(
                    condition => condition.type === conditionTypes.arrival
                );
                
                const deduplicationSettings = vm.connection.config.deduplicationSettings || {};
        
                vm.model = {
                    id: vm.connection.id,
                    generalSettings: {
                        name: vm.connection.name || '',
                        startDate: vm.connection.startDate,
                        isDisabled: vm.connection.isDisabled || false,
                        actionConditions: vm.connection.conditions.filter(
                            condition => condition.type === conditionTypes.action
                        ) || [],
                        arrivalCondition: arrivalCondition ? arrivalCondition.conditionId : '',
                        contentSettings: vm.connection.config.contentSettings || [],
                        groupByTitle:  vm.validGroupByTitle ? vm.connection.config.groupByTitle : true,
                        emailCampaign: vm.connection.config.emailCampaign || null,
                        steamCampaign: vm.connection.config.steamCampaign || null,
                        delay: vm.connection.config.delay || null
                    },
                    deduplicationSettings: {
                        isDisabled: deduplicationSettings.isDisabled || false,
                        fieldName: deduplicationSettings.fieldName || ''
                    }
                };    
                
                vm.cords = {x: vm.x, y: vm.y};
            },
            show(tab){
                this.initialTab = tab;
                this.resetModel();
                this.$refs.settings.show();
            },
            hide(){
                this.$refs.settings.hide();

            },
            saveConnection() {
                const vm = this;

                if(!this.isValid) {
                    return;
                }

                const model = {
                    name: vm.model.generalSettings.name,
                    id: vm.model.id,
                    isDisabled: vm.model.generalSettings.isDisabled,
                    startDate: vm.model.generalSettings.startDate,
                    conditions: vm.model.generalSettings.actionConditions.map(condition => ({
                        connectionId: vm.model.generalSettings.id,
                        conditionId: condition.conditionId,
                        type: conditionTypes.action,
                        operator: condition.operator
                    })),
                    config: {
                        contentSettings: vm.model.generalSettings.contentSettings,
                        deduplicationSettings: {
                            isDisabled: vm.model.deduplicationSettings.isDisabled,
                            fieldName: vm.model.deduplicationSettings.fieldName
                        },
                        emailCampaign: vm.model.generalSettings.emailCampaign,
                        steamCampaign: vm.model.generalSettings.steamCampaign,
                        groupByTitle: vm.model.generalSettings.groupByTitle,
                        delay: vm.model.generalSettings.delay
                    }
                };

                if(vm.model.generalSettings.arrivalCondition != '') {
                    model.conditions.push({
                        connectionId: vm.model.generalSettings.id,
                        conditionId: vm.model.generalSettings.arrivalCondition,
                        type: conditionTypes.arrival,
                        operator: null
                    });
                }

                vm.$refs.settings.hide();

                vm.$nextTick(() => {
                    vm.$emit('save', model);
                });
            },
            deleteConnection() {
                const vm = this;
                vm.$refs.settings.hide();

                vm.$nextTick(() => {
                    vm.$emit('delete', vm.model.id);
                });
            }
        },
        computed: {
            isValid() {
                return this.generalSettingsValid;
            },
            validGroupByTitle() {
                const vm = this;
                return vm.connection.config.groupByTitle != undefined && vm.connection.config.groupByTitle != null;
            },
            availableActionConditions() {
                const vm = this;

                const config = vm.connection.destinationBrick.config;
                const touchPointParentType = config != null && config.touchpointParentType;
                
                if(!touchPointParentType){
                    return [];
                }
                
                //We need to filter conditions on parent type.
                //However. Conditions are matched to sub types in the db, so we'll have to get somewhat creative.

                //Find all sub types that have our parent type as their parent.
                const types = vm.touchPointSubTypes.filter((type) => {
                    return type.parentType === touchPointParentType
                });

                //Now we filter our available conditions.
                return vm.availableConditions.filter(
                    (condition) => {
                        //If it's not an action condition we don't want it.
                        if(condition.type !== conditionTypes.action) {
                            return false;
                        }

                        //Loop the sub types that have our parent type
                        for(let i = 0 ; i < types.length ; i++) {

                            //The condition is valid if our sub type is linked to it.
                            const validType = condition.touchPointTypes.find((tpType) => tpType === types[i].id);

                            //Return true if the condition is valid. Else continue loop.
                            if(validType) {
                                return true;
                            }
                        }
                        return false;
                    }
                );
            },
            steamCampaign: {
                get: function () {
                    const vm = this;
                    const campaign = vm.steamCampaigns.find((campaign) => {
                        return campaign.id === vm.model.generalSettings.steamCampaign;
                    });
                    return campaign;
                },
                set: function(value) {
                    this.model.generalSettings.steamCampaign = value ? value.id : null;
                }
            },
            emailCampaign: {
                get: function () {
                    const vm = this;
                    const campaign = vm.emailCampaigns.find((campaign) => {
                        return campaign.id === vm.model.generalSettings.emailCampaign;
                    });
                    return campaign;
                },
                set: function(value) {
                    this.model.generalSettings.emailCampaign = value ? value.id : null;
                }
            },
            groupByTitle: {
                get: function () {
                    const vm = this;
    
                    return vm.model.generalSettings.groupByTitle === null ? true 
                        : vm.model.generalSettings.groupByTitle === undefined ? true 
                        : vm.model.generalSettings.groupByTitle;
                },
                set: function(value) {
                    const vm = this;
                    vm.model.generalSettings.groupByTitle = value;
                }
            }
        },
        data: () => ({
            generalSettingsValid: false,
            
            model: {
                generalSettings: {},
                deduplicationSettings: {}
            },
            tabs: tabs,
            initialTab: undefined,
            touchPointTypes: [],
            touchPointSubTypes: [],
            emailCampaigns: [],
            steamCampaigns: [],
            modalSize: sizes.large
        }),
        props: {
            connection: {
                type: Object,
                required: true
            },
            availableConditions: {
                type: Array,
                required: true
            }
        }
    }
    
    export {
        tabs
    }
</script>

<style scoped src="../../../Style/journey-connection-settings.scss" lang="scss">

</style>